<template>
  <div>
    <title-bar title="运行情况统计表">
      <el-button type="default" @click="$router.back()" icon="fa fa-angle-left">返回</el-button>
    </title-bar>
    <div class="page-body">
      <el-form v-model="queryForm" inline>
        <el-form-item label="所属单位">
          <comp-select v-model="queryForm.compId" @change="query"></comp-select>
        </el-form-item>
        <el-form-item label="设备类型">
          <code-select code-type="DEVICE_TYPE" v-model="queryForm.deviceType" @change="query"></code-select>
        </el-form-item>
        <el-form-item label="设备">
          <el-input v-model.trim="queryForm.deviceName" placeholder="请输入编码、名称或地址模糊查询" clearable></el-input>
        </el-form-item>
        <el-button type="primary" icon="fa fa-search" :loading="loading" @click="query">查询</el-button>
        <el-button type="primary" icon="fa fa-download" :loading="loading" @click="download">导出</el-button>
      </el-form>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center" fixed></el-table-column>
        <el-table-column prop="compName" label="单位名称" align="center" min-width="150" fixed></el-table-column>
        <el-table-column prop="deviceCode" label="设备编号" align="center" min-width="120" fixed></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" min-width="120"></el-table-column>
        <el-table-column prop="address" label="地址" min-width="150"></el-table-column>
        <el-table-column prop="online" label="在线" align="center" width="50" v-slot="{row}">
          <i v-if="row.online" class="fa fa-chain color-success" title="在线"></i>
          <i v-else class="fa fa-chain-broken color-error" title="离线"></i>
        </el-table-column>
        <el-table-column prop="deviceTypeName" label="类型" align="center" width="60"></el-table-column>
        <el-table-column prop="kwh" label="外接电表" align="center" width="80"></el-table-column>
        <el-table-column prop="selfKwh" label="新风电量" align="center" width="80"></el-table-column>
        <el-table-column prop="createTime" label="启用日期" align="center" min-width="90" v-slot="{row}">
          <span>{{row.createTime.substr(0,10)}}</span>
        </el-table-column>
        <el-table-column prop="saveKwh" label="累计节电量" align="center" min-width="90"></el-table-column>
        <el-table-column prop="savePercent" label="节电率(%)" align="center" min-width="90" v-slot="{row}">
          <span v-if="row.savePercent">{{row.savePercent}}%</span>
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>
  </div>
</template>

<script>
import * as querystring from "querystringify"
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CompSelect from "@/components/base/CompSelect";
import SessionStore from "@/utils/SessionStore";
import CodeSelect from "@/components/base/CodeSelect.vue";
export default {
  components: {CodeSelect, CompSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      user: {
      },
      queryForm: {
        compId: '',
        deviceType: '',
        deviceName: '',
        page: 1,
        limit: 10
      },
      total: 0,
      records: []
    }
  },
  created() {
    this.user = SessionStore.getUser();
    this.query();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/device-day-info/total-list", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    download() {
      let params = querystring.stringify(this.queryForm || {});
      window.open(this.globalConfig.apiRoot+"/device-day-info/export-total-list?"+params);
    }
  }
}
</script>

<style scoped>

</style>